import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  standalone: false,
})
export class ErrorComponent {
  generateError() {
    throw new Error('Error testing.');
  }
}
